import { useTranslation } from 'react-i18next'

import {
  getVerticalIconChevronDirection,
  IconChevron,
  IconNG,
} from '../../Icon'
import { TaskTypeListItem } from '../TaskTypeListItem'

import * as styles from './TaskTypeListMoreButton.module.css'

function TaskTypeListMoreButton({
  activeItem,
  disabled,
  icon,
  id,
  isOpen,
  ref,
  onClick,
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    onClick?.(event)
  }

  return (
    <div ref={ref} onClick={handleClick}>
      <TaskTypeListItem
        activeItem={activeItem}
        className={styles.button}
        disabled={disabled}
        icon={icon}
        id={id}
        isCircle={false}
        name={t('Task.FormTypeFieldShowMoreBtnTooltipKey')}
      >
        <IconNG
          Icon={IconChevron}
          iconProps={{
            direction: getVerticalIconChevronDirection(isOpen),
          }}
        />
      </TaskTypeListItem>
    </div>
  )
}

export default TaskTypeListMoreButton
